/**
 * Created by carlhaynes on 9/28/17.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Panel, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom'

class ArtistItem extends Component {

  constructor(props) {
    super(props);
      this.gotoArtistPage = this.gotoArtistPage.bind(this);
  }

  componentWillMount() {
    //console.log("ArtistItem componentWillMount");
  }

  gotoArtistPage(event) {
      this.props.history.push('/artist/' + this.props.artist.uid);
  }

  render() {

    var divStyle = {
      background: "#eee",
      padding: "10px",
      margin: "10px",
      border: "1px solid black"
    };


    let artist = this.props.artist;

    return (
      <Col xs={6} md={4}>
        <Panel header={artist.email}>

            <div style={divStyle}>
          Panel content - {artist.displayName}
          </div>

          <Button bsStyle="primary" onClick={event => this.gotoArtistPage(event)}>View Artist</Button>
        </Panel>
      </Col>
    );
  }
}

ArtistItem.propTypes = {
  artist: PropTypes.object
};

export default withRouter(ArtistItem);



// WEBPACK FOOTER //
// ./src/Components/ArtistItem.jsx